import type { PendingInteraction } from "@/stores/types";

/**
 * The composer's placeholder while the story is asking (V2, non-blocking
 * asks). A handoff says where to finish (spec 2026-09-02): in the browser, or
 * on the phone; a value ask, like any question, invites the composer too.
 */
export function deskPlaceholder(pending: PendingInteraction | null): string {
  if (pending?.type === "question" && pending.intent === "handoff") {
    if (pending.surface === "browser")
      return "Finish in the browser, or tell Bash";
    if (pending.surface === "phone")
      return "Finish on your phone, or tell Bash";
  }
  return "Answer above, or tell Bash";
}
